const data = {
  id: 1,
  title: 'Read and complete the paragraph with the given words',
  subTitle: 'Đọc và điền từ để hoàn thành đoạn văn',
  words: ['go', 'free', 'watch'],
  questions: ['Hoa: What do you in your # time?', 'Quan: I often # sport programmes on TV. What about you?', 'Hoa: I # to the music club with my friends.'],
  answers: ['free', 'watch', 'go'],
  settings: {
    showNumber: false,
  },
};

export default data;
